import {Injectable} from '@angular/core';
import {AngularFirestore} from '@angular/fire/compat/firestore';
import {Ordered} from '../models/ordered';
import {Agenda} from '../models/agenda';
import {Product, ProductItem} from '../models/product';
import {Member} from '../models/member';
import {PendingDoc} from '../models/pending-doc';
import {SnackBarIconService} from '../shared/snack-bar-icon/snack-bar-icon.service';
import {AngularFireStorage, AngularFireStorageReference, AngularFireUploadTask} from '@angular/fire/compat/storage';
import {finalize} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ReportsSubscriptionsService {

  public objectImage: any = null; // store input file for avatar
  public storedImage: any; // store url image for local preview

  constructor (
    private db: AngularFirestore,
    private snackBar: SnackBarIconService,
    private fs: AngularFireStorage,
  ) { }

  loadCategories () {
   // return [ {"id": "m6BwcqDAZMyVKJZYCWqV", "name": "Acadêmico"}, {"id": "GJ8jZNUOEulUZPVGu9F8", "name": "Acadêmico DBLACCV"}, {"id": "XkNpL8lctQ82mVgSXruw", "name": "Aspirante"}, {"id": "vPFeWOFfTUGjYKQ4dd3C", "name": "Associado"}, {"id": "f9IKy8nfJsjvBwO390uT", "name": "Especialista"}, {"id": "QztTcPGRDoB08EZkaUci", "name": "Honorário"}, {"id": "ukfcX7BgmsNCkpz0gnKL", "name": "LACES (Cirurgião)"}, {"id": "3pf0YhenFgEpoVzIvn8i", "name": "LACES (Residentes)"}, {"id": "H2AoWhktluQaWYuPydHC", "name": "Não Sócio"}, {"id": "B8PSEcvlWnLwvwwB0NOR", "name": "Remido"}, {"id": "9BfCN5Eb94qVk7xRRQuT", "name": "Residente SBCCV"}, {"id": "ALUtUchCqgw72vtDLqfm", "name": "Residente/Especializando em Medicina"}, {"id": "TJYc58rFDvJJ0R7AL47Y", "name": "SPCCTV"}, {"id": "9SWyrc8TgRaUEWmfkr95", "name": "Titular"} ]
   return this.db.collection<Product>('sbccv_subcategories', ref => ref
   .orderBy('name', 'asc')).get()
  
  }

  /////////////////////////////////////////

  isValidCPF (cpf: string): boolean {
    if (typeof cpf !== "string") return false;
    let _cpf = cpf.replace(/[\s.-]*/igm, '');

    if (_cpf.length !== 11 || !Array.from(_cpf).filter(e => e !== _cpf[ 0 ]).length) {
      return false;
    }
    let soma = 0;
    let resto;
    for (let i = 1; i <= 9; i++)
      soma = soma + parseInt(_cpf.substring(i - 1, i)) * (11 - i);
    resto = (soma * 10) % 11;
    if ((resto == 10) || (resto == 11)) resto = 0;
    if (resto != parseInt(_cpf.substring(9, 10))) return false;
    soma = 0;
    for (let i = 1; i <= 10; i++)
      soma = soma + parseInt(_cpf.substring(i - 1, i)) * (12 - i);
    resto = (soma * 10) % 11;
    if ((resto == 10) || (resto == 11)) resto = 0;
    if (resto != parseInt(_cpf.substring(10, 11))) return false;
    return true;
  }

  isValidEmail (email: string): boolean {
    var emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    return email.match(emailRegex) ? true : false
  };

  loadProducts () {
    return this.db.collection<Product>('sbccv_products', ref => ref
      .where('deleted', '==', false)
      .orderBy('name', 'asc')).snapshotChanges()
  }

  selectAllProductsNoAnnuities () {
    return this.db.collection<Product>('sbccv_products', ref => ref
      .where('deleted', '==', false)
      .where('part_of', '<', 3)
      .orderBy('part_of', 'asc')
      .orderBy('name', 'asc')).snapshotChanges()
  }
  
  getProductItens (product_id) {
    return this.db.collection<ProductItem>('sbccv_product_itens', ref => ref
      .where('product_id', '==', product_id)
      .orderBy('event_name', 'asc'))
      .get()
  }

  //////////////////////////////////////////
  getOrders (product_id: string) {
    return this.db.collection<Ordered>('sbccv_orders', ref => ref
      .where("returnCode", "==", "00")
      .where("product_id", "==", product_id)
      .orderBy("date", 'desc')
      .orderBy("member_name")).snapshotChanges();
  }

  selectAgendaStaff (event_id) {
    return this.db.collection<Agenda>('sbccv_agenda', ref => ref
      .where('event_id', '==', event_id)
      .orderBy("event_name", 'desc')).get();
  }

  update (entity: any) {
    let id = entity.id;
    delete entity.id;
    console.log("service update entity: " + JSON.stringify(entity))
    return this.db.collection('sbccv_orders').doc(id)
     .set(Object.assign({}, entity), {'merge': true});
  }

  updateStaff (entity: any) {
    let id = entity.id;
    delete entity.id;

    return this.db.collection('sbccv_members').doc(id)
      .set(Object.assign({}, entity), {'merge': true});

  }


  compareNames (a, b) {
    const pa = String(a.member_name)
    const pb = String(b.member_name)

    if (pa > pb) return 1;
    if (pb > pa) return -1;
    return 0;

  }

  loadMemberStaffs () {
    return this.db.collection<Member>('sbccv_members', ref => ref
      .where("staff", "==", true)
    ).snapshotChanges()//.get();
  }

  loadMembers () {
    return this.db.collection<Member>('sbccv_members', ref => ref
      .orderBy("name")
    ).snapshotChanges()//.get();
  }

  loadDocuments () {
    return this.db.collection<PendingDoc>('sbccv_pendingdocs', ref => ref
      .orderBy('member_name', 'asc')).get();
  }



  previewImage (event) {

    if (event.target.files.length === 0)
      return;

    var mimeType = event.target.files[ 0 ].type;
    if (mimeType.match(/image\/*/) == null) {
      this.snackBar.openSnackBar("Apenas arquivos .png", '', 'info');
      return;
    }

    var reader = new FileReader();
    this.objectImage = event.target.files[ 0 ];
    reader.readAsDataURL(event.target.files[ 0 ]);
    reader.onload = (_event) => {
      this.storedImage = reader.result;
      return event.target.files[ 0 ];
    }
  }

  uploadImage (file, entity_id) {
    const fsRef: AngularFireStorageReference = this.fs.ref("images/members/" + entity_id + ".png");
    const fsTask: AngularFireUploadTask = fsRef.put(file);

    fsTask.snapshotChanges().pipe(
      finalize(() => {
        fsRef.getDownloadURL().subscribe(url => {
          this.updateImage(entity_id, url)
            .then((result) => {
              //  console.log("result: " + JSON.stringify(result))
              //form.controls.image.setValue(result);
              return result
            })
        });
      }))
      .subscribe();
  }

  updateImage (entity_id: any, image: any) {
    return this.db.collection('sbccv_members').doc(entity_id).set({image: image}, {merge: true})
      .then(() => {
        this.objectImage = ""
        return image;
      })
      .catch((err) => {
        console.log("erro upadate image: " + JSON.stringify(err))
      })
  }

}

